module.exports = __webpack_public_path__ + "img/binDodIcon.6482d417.svg";